import ObjectType from './ObjectType';
const StringType = Object.seal({
    fullName: 'String',
    name: 'String',
    namespace: '',
    baseType: ObjectType,
    isArray: false,
    factory: String,
});
export default StringType;
